import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '注册送彩金需要充值吗？',
    answer: '大部分正规平台的注册彩金是新用户专属福利，完成注册即可免费领取，无需额外充值。但请注意，彩金通常需要满足一定的流水要求后才能提现。建议在注册前仔细阅读平台的彩金使用规则。',
  },
  {
    question: '彩金到账需要多长时间？',
    answer: '到账时间因平台而异。优质平台通常在注册完成后即时到账或5分钟内到账；部分平台可能需要人工审核，一般在24小时内到账。如果超过24小时未到账，建议联系平台客服咨询。',
  },
  {
    question: '注册彩金可以直接提现吗？',
    answer: '通常情况下，注册彩金不能直接提现。彩金属于平台的营销福利，需要完成指定的流水（投注金额）要求后才能申请提现。不同平台的流水要求不同，一般在1-5倍之间。建议选择流水要求合理的平台。',
  },
  {
    question: '一个手机号可以在多个平台注册吗？',
    answer: '可以。同一个手机号通常可以在不同平台分别注册并领取各平台的新人彩金。但同一平台一般限制一个手机号只能注册一个账号，重复注册可能导致账号被封禁。',
  },
  {
    question: '如何辨别靠谱的送彩金平台？',
    answer: '可以从以下几个方面判断：(1) 查看平台运营资质和许可证；(2) 搜索平台口碑和用户评价；(3) 测试客服响应速度和服务质量；(4) 阅读平台的彩金规则是否透明清晰；(5) 关注我们"彩金汇"的权威平台评测，选择经过验证的优质平台。',
  },
  {
    question: '注册彩金有有效期吗？',
    answer: '是的，大多数平台的注册彩金有7-30天的有效期限制。请在领取彩金后尽快查看有效期信息，并在有效期内使用完毕，逾期彩金将自动失效。建议领取后合理规划使用时间。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">常见问题解答</h2>
          <p className="text-sm text-foreground-500">关于注册送彩金的常见疑问，这里都有答案</p>
        </div>
        <div className="space-y-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <span className="font-medium text-foreground-800 text-sm md:text-base pr-4">{item.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}